import { z } from 'zod'

export const SessionUserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string().optional(),
  isSuper: z.boolean().default(false),
  permissions: z.array(z.string()).default([]),
})

export type SessionUser = z.infer<typeof SessionUserSchema>
